// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261704/js/" + chunkId + "." + {"44":"63ec43d6","225":"b8e0ce71","481":"a9b76788","486":"8d80f1af","770":"e963d79d"}[chunkId] + ".0.6853230282052004.chunk.js";
};